import { useTranslation } from "react-i18next";

export const useValidators = () => {
  const { t } = useTranslation();

  const required = {
    required: true,
    message: t("dashboard.form.required"),
  };

  const email = {
    type: "email" as const,
    message: "Please enter a valid email address",
  };

  return {
    required,
    email,
  };
};
